import { Switch } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { useContext } from 'react'
import {ColorModeContext} from '../../../../AppThemeProvider'
import { icons } from '../../../../assets'
import { getMediaUrl } from '../../../../helpers'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'


const SwitchTheme = styled(Switch)(({ theme}) => ({
	'.MuiSwitch-switchBase': {
		background: theme.palette.mode === 'dark' ? '#6B6F77' : '#FFFFFF',
		height: '28px',
		left: '2px',
		padding: '7px',
		top: '2px',
		width: '28px'
	},
	'.MuiSwitch-switchBase+.MuiSwitch-track': {
		':before':	{
			content: `url(${ getMediaUrl() + icons.sunDark })`
		},
		background: theme.palette.mode === 'dark' ? '#101011' : '#131635',
		opacity: 1,
		paddingLeft: '39px',
		paddingTop:	'8px'
	},
	'.MuiSwitch-switchBase.Mui-checked': {
		':hover': {
			background: '#6B6F77'
		},
		left: '13px'
	},
	'.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
		':before': {
			content: `url(${ getMediaUrl() + icons.moon })`
		},
		background: '#131635',
		opacity: 1,
		padding: '8px 9px'
	},
	borderRadius: '43px',
	height: '32px',
	padding: 0,
	width: '63px'
}))

const ThemeContainer = () => {
	const { theme } = useDefaultComponentTools()
	const colorMode = useContext(ColorModeContext)
	const mediaUrl = getMediaUrl()
	return (
		<SwitchTheme
			checked={theme.palette.mode === 'light'}
			onChange={() => colorMode.toggleColorMode()}
			icon={<img src={mediaUrl + icons.moon} alt='moon'/>}
			checkedIcon={<img src={mediaUrl + icons.sun} alt='sun'/>}
		/>
	)
}

export default ThemeContainer
